var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C6C6C6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,1C8.3,1,8.2,1,8,1V0c0.2,0,0.4,0,0.6,0C8.6,0,8.5,1,8.5,1z M10.5,1.5c-0.3-0.1-0.6-0.2-1-0.3l0.2-1 c0.4,0.1,0.8,0.2,1.1,0.3C10.9,0.5,10.5,1.5,10.5,1.5z M11.9,2.2c-0.1-0.1-0.3-0.2-0.4-0.3L11.9,1c0.3,0.2,0.7,0.4,1,0.7l-0.6,0.8 C12.2,2.4,12,2.3,11.9,2.2L11.9,2.2z M13.7,4c-0.2-0.3-0.4-0.5-0.7-0.8l0.7-0.7c0.3,0.3,0.5,0.6,0.7,0.9L13.7,4z M14.5,5.3 c-0.1-0.2-0.1-0.3-0.2-0.5l0.9-0.4c0.2,0.4,0.3,0.7,0.4,1.1l-0.9,0.3C14.6,5.6,14.5,5.5,14.5,5.3z M15,7.8c0-0.3,0-0.7-0.1-1l1-0.2 C15.9,7,16,7.4,16,7.8L15,7.8L15,7.8z M14.9,9.4c0-0.2,0.1-0.3,0.1-0.5l1,0.1c0,0.4-0.1,0.8-0.2,1.2l-1-0.3 C14.8,9.7,14.8,9.5,14.9,9.4z M13.9,11.7c0.2-0.3,0.3-0.6,0.5-0.9l0.9,0.4c-0.2,0.4-0.3,0.7-0.6,1C14.8,12.3,13.9,11.7,13.9,11.7z  M13,12.9c0.1-0.1,0.2-0.2,0.4-0.4l0.8,0.7c-0.1,0.1-0.3,0.3-0.4,0.4C13.7,13.7,13,12.9,13,12.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7c1.9,0,3.6-0.7,4.9-2.1l0.7,0.7c-3.1,3.1-8.2,3.1-11.3,0s-3.1-8.2,0-11.3 C3.8,0.8,5.9,0,8,0V1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,3C7.8,3,8,3.2,8,3.5v5.2l3.2,1.9c0.2,0.1,0.3,0.4,0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.2l-3.5-2 C7.1,9.3,7,9.2,7,9V3.5C7,3.2,7.2,3,7.5,3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.4c26e265a00c999866ee71299e3454f2.svg";
export { ForwardRef as ReactComponent };